module.exports = __webpack_public_path__ + "img/P150T_weapon_111.bf4ffd1f.png";